import { render, staticRenderFns } from "./GuideComponent.vue?vue&type=template&id=689c590e&scoped=true"
import script from "./GuideComponent.vue?vue&type=script&lang=js"
export * from "./GuideComponent.vue?vue&type=script&lang=js"
import style0 from "./GuideComponent.vue?vue&type=style&index=0&id=689c590e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c590e",
  null
  
)

export default component.exports